import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RoleMaintenanceRoutingModule } from './role-maintenance-routing.module';
import { RoleMaintenanceComponent } from './role-maintenance.component';
import { RoleMaintenanceFormComponent } from './role-maintenance-form/role-maintenance-form.component';
import { GlobalModulesModule } from 'src/app/core/global-modules/global-modules.module';
import { MaintenanceListModule } from 'src/app/core/custom-modules/maintenance-list/maintenance-list.module';
import { MaintenanceDetailModule } from 'src/app/core/custom-modules/maintenance-detail/maintenance-detail.module';
import { RoleMaintenanceFilterComponent } from './role-maintenance-filter/role-maintenance-filter.component';

@NgModule({
  imports: [
    CommonModule,
    GlobalModulesModule,
    MaintenanceListModule,
    MaintenanceDetailModule,
    RoleMaintenanceRoutingModule
  ],
  declarations: [RoleMaintenanceComponent, RoleMaintenanceFormComponent, RoleMaintenanceFilterComponent],
  entryComponents: [RoleMaintenanceFilterComponent]
})
export class RoleMaintenanceModule { }
